// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"467":"6a1fe657","496":"0a1bd7ad"}[chunkId] + ".chunk.css";
};